import { PaymentStatus } from '../models/Order';

const translatePaymentStatus = (status: PaymentStatus) => {
  switch (status) {
    case PaymentStatus.PENDING:
      return 'Oczekujące';
    case PaymentStatus.COMPLETED:
      return 'Zapłacone';
    case PaymentStatus.FAILED:
      return 'Nieudane';
    case PaymentStatus.REFUNDED:
      return 'Zwrócone';
    default:
      return '';
  }
};

export default translatePaymentStatus;
